export const moreLinks = [
  {
    label: 'Reckon one help centre',
    url: 'https://help.reckon.com/reckon-one',
  },
  {
    label: 'How-to tutorial videos',
    url:
      'https://www.youtube.com/playlist?list=PLoUtvAKOpZWtgg7h76_CKdR5S_MesEFbG',
  },
  {
    label: 'Ask the Reckon Community a question',
    url: 'https://community.reckon.com/categories/reckonone',
  },
  {
    label: 'Ask the support team a question',
    url: 'https://www.reckon.com/au/support/ticket',
  },
  {
    label: 'Submit a product suggestion',
    url: 'https://community.reckon.com/categories/reckononeideas',
  },
  {
    label: 'Contact us',
    url: 'https://www.reckon.com/au/contact-us/#reckon-one',
  },
  {
    label: "What's new in Reckon One",
    url:
      'https://community.reckon.com/discussions/tagged/reckon-one-release-notes',
  },
];
